import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=b4672f12&scoped=true"
import script from "./ProjectEdit.vue?vue&type=script&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&lang=js"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=b4672f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4672f12",
  null
  
)

export default component.exports